<div class="card shadow-sm rounded-0 border-0">
     <div class="card-body">
          <h2 id="supportHeaderDiv" class="card-title h5 mt-0">
               <span [innerHtml]="'HaveQuestions' | translator: 'base'">Have Questions?</span>
          </h2>
          <p [innerHTML]="'DashboardCustomerSupport' | translator: 'base'">
               The PSP customer service team is available Monday through Thursday from 8 AM to 6 PM ET, and on Friday
               from 8 AM to 5 PM ET. Chat with us using the \"LIVE HELP\" button in the top-right corner of this page,
               email us at
               <a href="mailto:PSPHelp@tylertech.com" title="PSPHelp@tylertech.com" name="PSPHelp@tylertech.com"
                    id="PSPHelp@tylertech.com">PSPHelp&#64;tylertech.com</a>, or call us toll-free at
               <a href="tel:1-877-642-9499" title="1-877-642-9499" id="1-877-642-9499"
                    name="1-877-642-9499">1-877-642-9499</a>.
          </p>
          <button [routerLink]="'/customerSupport'" class="btn btn-outline-primary btn-sm"
               [title]="'Contact' | translator: 'base'" name="customerSupportLink" id="customerSupportLink"
               tabindex="0">
               <span [innerHtml]="'Contact' | translator: 'base'">Contact</span>
          </button>
     </div>
</div>